import { Link, useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import { logOut, openSideNav, registerRoutes } from '../../../func';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import M from '@materializecss/materialize';
import Axios from 'axios';
import moment from 'moment';
import * as xlsx from 'xlsx';

const ShipmentByBuyingGroup = () => {
  const { path } = useRouteMatch();
  const authData = useMemo(
    () => JSON.parse(localStorage.getItem('auth_data')),
    []
  );

  const selectRef = useRef(null);

  const initValues = () => ({
    buyingGroupId: '',
  });

  const [values, setValues] = useState(initValues());
  const [buyingGroupList, setBuyingGroupList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const networkCalls = useMemo(
    () =>
      registerRoutes(
        {
          getBuyingGroups: {
            func: () => {
              Axios.get('/api/v2/buyinggroup/read/all', {
                params: authData,
              })
                .then(result => setBuyingGroupList(result.data))
                .catch(logOut);
            },
            type: 'r',
          },
          generateReport: {
            func: buyingGroupId => {
              setLoading(true);

              Axios.get('/api/v2/report/lastshipment', {
                params: {
                  ...authData,
                  buyingGroupId,
                },
              })
                .then(result => setData(result.data))
                .catch(logOut)
                .finally(() => setLoading(false));
            },
            type: 'r',
          },
        },
        path
      ),
    [path, authData]
  );

  const onChange = ({ target: { id, value } }) =>
    setValues(prev => ({ ...prev, [id]: value }));

  useEffect(() => {
    networkCalls.getBuyingGroups();
  }, []);

  useEffect(() => {
    const { current } = selectRef;
    if (!current) return;

    M.FormSelect.init(current);

    return () => M.FormSelect.getInstance(current)?.destroy();
  }, [selectRef.current, buyingGroupList]);

  const generateReport = useCallback(
    event => {
      event?.preventDefault();
      networkCalls.generateReport(values.buyingGroupId);
    },
    [values, selectRef]
  );

  const downloadReport = useCallback(
    event => {
      event?.preventDefault();
      const wb = xlsx.utils.book_new();
      let maxNameWidth = 0;

      const sheet = xlsx.utils.json_to_sheet(
        data.map(({ name, customerNumber, timestamp, orderNumber }) => {
          const wName = name.trim().length;
          if (wName > maxNameWidth) maxNameWidth = wName;

          return {
            Pharmacy: name.trim(),
            'Customer Number': customerNumber,
            'Order Number': orderNumber || 'N/A',
            'Date Received': timestamp || 'N/A',
          };
        })
      );

      sheet['!cols'] = [
        { wch: maxNameWidth + 2 },
        { wch: 11 },
        { wch: 9 },
        { wch: 20 },
      ];
      const today = moment().format('MMM DD, YYYY');

      xlsx.utils.book_append_sheet(wb, sheet, today);
      xlsx.writeFile(
        wb,
        `latest_shipment_report_${moment().format('YYYY_MM_DD')}.xlsx`
      );
    },
    [data, values, buyingGroupList]
  );

  return (
    <div className="main">
      <div className="row">
        <div className="row">
          <div style={{ display: 'flex' }}>
            <Link to="/" onClick={openSideNav} style={{ marginRight: '12px' }}>
              <i className="material-icons black-text">menu</i>
            </Link>
            <Link to="/">Home</Link>
            <i className="material-icons">chevron_right</i>
            <span className="grey-text">Last Shipment Report</span>
          </div>
        </div>
        <div className="row">
          <h5 className="center">Last Shipment Received Report</h5>
        </div>
        <div className="row">
          <div className="input-field col s12 m4">
            <select
              ref={selectRef}
              id="buyingGroupId"
              value={values.buyingGroupId}
              onChange={onChange}
            >
              <option value="">Any Buying Group</option>
              {buyingGroupList.map(({ id, name }) => (
                <option key={id} value={id}>
                  {name}
                </option>
              ))}
            </select>
            <label htmlFor="buyingGroupId">Buying Group (GPO)</label>
          </div>
          <div className="input-field col s12 m3">
            <a
              href="/"
              className="btn-small blue white-text waves-effect waves-light col s12"
              onClick={generateReport}
            >
              Generate Report
            </a>
          </div>
        </div>
      </div>
      <div className="row">
        {loading ? (
          <div className="progress white">
            <div className="indeterminate blue" />
          </div>
        ) : (
          <>
            <div className="row">
              <div className="col s12 m2 offset-m10">
                {data?.length ? (
                  <a
                    href="/"
                    className="btn-small blue white-text waves-effect waves-light col s12"
                    onClick={downloadReport}
                  >
                    Download As Excel
                  </a>
                ) : null}
              </div>
            </div>
            <table className="highlight">
              <thead>
                <tr>
                  <th>Pharmacy</th>
                  <th>Customer Number</th>
                  <th>Order Number</th>
                  <th>Last Box Received</th>
                </tr>
              </thead>
              <tbody>
                {data?.map(
                  ({ id, name, customerNumber, timestamp, orderNumber }) => (
                    <tr key={id}>
                      <td style={{ padding: '2px' }}>{name}</td>
                      <td style={{ padding: '2px' }}>{customerNumber}</td>
                      <td style={{ padding: '2px' }}>{orderNumber}</td>
                      <td style={{ padding: '2px' }}>
                        {timestamp
                          ? moment(timestamp).format('MM/DD/YY hh:mmA')
                          : ''}
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </>
        )}
      </div>
    </div>
  );
};

export default ShipmentByBuyingGroup;
